<template>
  <div class="isMember">
    <div class="flex space-between">
      <div class="member-header">
        <div v-if="inputHide" class="header-box">
          <!-- <el-input placeholder="请输入手机号" v-model="memberMsg" @focus="handleFocus" @blur="hideBox" @input="changeInputValue" clearable @clear="clearMember" class="input-with-select" prefix-icon="el-icon-search" style="width:471px;height: 47px;">
                        <el-button type="primary" slot="append" @click="selectMember">搜索会员</el-button>
          </el-input>-->
          <!-- <el-input
            placeholder="请输入会员手机号或者身份证号码"
            v-model="query.keyword"
            clearable
            @clear="removeDoQuery"
            @keyup.enter.native="rulesMobile"
            class="input-with-select"
            prefix-icon="el-icon-search"
          ></el-input>-->
          <el-input
            placeholder="请输入手机号/身份证"
            v-model="memberMsg"
            @focus="handleFocus"
            @blur="hideBox"
            @input="changeInputValue"
            clearable
            maxlength="18"
            @clear="clearMember"
            class="input-with-select"
            prefix-icon="el-icon-search"
          />
          <el-button class="search-button" @click="selectMember">搜索会员</el-button>
        </div>
        <div class="member_bg" v-else>
          <div class="flex-row">
            <el-avatar class="ml10 img" :src="list.headImgUrl" v-if="list.headImgUrl"></el-avatar>
            <el-avatar class="ml10 img" :src="headImg" v-else></el-avatar>
            <p class="ml10">{{list.nickName?list.nickName:list.realName}} {{list.mobile ? list.mobile :list.idCardNo}}</p>
            <p style="margin-left: 40px;">账户余额: <span class="moneys">￥{{ list.walletAmount}}</span></p>
          </div>
          <p class="icons el-icon-circle-close" @click="handleInputHide"></p>
        </div>
      </div>
      <div class="member-box" v-if="memberHide">
        <div class="list" v-if="list">
          <p style="padding: 10px;">会员信息</p>
          <div class="flex-row p10" @click="clickMember(list)">
            <el-avatar :src="list.headImgUrl" v-if="list.headImgUrl"></el-avatar>
            <el-avatar :src="headImg" v-else></el-avatar>
            <div class="msg ml10">
              <p>
                {{ list.mobile ? list.mobile : list.idCardNo}}
                <span>({{ list.nickName?list.nickName:list.realName }})</span>
              </p>
              <p>可用余额: {{ list.walletAmount }}</p>
            </div>
          </div>
        </div>
        <div class="no-result" v-else>
          <p>暂无搜索结果</p>
          <p class="ml10 bind-member-active" @click="addClick">注册会员</p>
        </div>
      </div>
      <div class="member-box" v-if="focusHide && historyMobile">
        <div class="p10">
          <p style="padding: 10px 10px 0;">历史记录</p>
          <el-button
            class="mt10 history-btn"
            @click="handleHistory(historyMobile)"
          >{{ historyMobile }}</el-button>
        </div>
      </div>
    </div>
    <edit-set ref="editSetForm" :value="memberMsg" @change="editChange"></edit-set>
  </div>
</template>

<script>
import minxin from "../../assets/javascript/minxin.js";
import editSet from "../member/edit.vue";
export default {
  mixins: [minxin],
  components: {editSet},
  props: {
    mobile: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      dialogVisible: false,
      codeName: true,
      memberHide: false,
      inputHide: true,
      memberMsg: "",
      list: {},
      headImg: require("../../assets/images/headerImg.png"),
      focusHide: false,
      historyMobile: ""
    };
  },
  created() {
    if (this.mobile) {
      this.memberMsg = this.mobile;
      this.selectMember();
      // this.clickMember(this.list);
    }
  },
  watch: {
    mobile (o) {
      if (o) {
        this.memberMsg = this.mobile;
        this.selectMember();
        // this.clickMember(this.list);
      }
    }
  },
  methods: {
    addClick() {
        // 注册会员
        this.$refs["editSetForm"].$emit("set", null)
    },
    editChange(bool) {
      if (bool) {
        this.selectMember();
      }
    },
    changeInputValue(value) {
      this.memberMsg = value;
      if (this.memberMsg.length == 18 || this.memberMsg.length == 11) {
        this.selectMember();
        this.focusHide = false;
      }
    },
    handleFocus(value) {
      this.historyMobile = localStorage.getItem("historyMobile");
      this.focusHide = true;
    },
    hideBox() {
      setTimeout(() => {
        this.focusHide = false;
      }, 300);
    },
    handleHistory(msg) {
      this.changeInputValue(msg);
    },
    gotoCenter() {
      // window.close();
      this.$router.push(`/collectMoney/center`);
    },
    handleInputHide() {
      this.memberHide = false;
      this.inputHide = true;
      this.memberMsg = "";
      this.list = {};
      this.$store.commit("setMemberMobile", null);
      this.$emit("handleChange", "");
    },
    clickMember(list) {
      this.memberHide = false;
      this.inputHide = false;
      this.$store.commit("setMemberMobile", this.list.mobile);
      this.$emit("handleChange", this.list);
    },
    clearMember() {
      this.memberHide = false;
      this.focusHide = false;
      this.memberMsg = ""
      this.list = {};
      this.$store.commit("setMemberMobile", null);
      this.$emit("handleChange", "");
    },
    selectMember() {
      if (this.memberMsg != "") {
        this.$api
          .get(this.$url.member.search, {
            keyword: this.memberMsg
          })
          .then(res => {
            if (res) {
              this.list = res;
              this.memberHide = true;
              // this.$emit('handleChange',this.list.id);
            } else {
              this.list = res;
              this.memberHide = true;
            }
            if (this.mobile) {
              this.clickMember(this.list);
            }
          })
          .catch(error => {});
      } else {
        this.$message.warning("请输入客户手机号");
      }
    }
  }
};
</script>
<style scoped lang="less">
@import "../../assets/css/edit.less";
.isMember {
  position: relative;
}
.member-header {
  width: 100%;
  height: 88px;
  padding: 0 25px;
  display: flex;
  align-items: center;
  border-bottom: 2px solid @borderColor;
  .header-box {
    width: 100%;
    display: flex;
    box-sizing: border-box;
  }
  .search-button {
    width: 113px;
    height: 32px;
    color: @blue;
    font-size: 16px;
    text-align: center;
    border: 1px solid @blue;
    border-radius: 5px;
    box-sizing: border-box;
    cursor: pointer;
    &:hover {
      background: #fff;
    }
  }
  .input-with-select {
    width: 100%;
    height: 48px;
    margin-right: 15px;
    /deep/ .el-input__inner {
      height: 48px;
      line-height: 48px;
      padding-left: 35px;
    }
    /deep/ .el-input__clear {
      font-size: 22px;
      line-height: 48px;
    }
    /deep/ .el-input__prefix {
      color: @blue;
      font-size: 24px;
      margin-right: 10px;
      .el-input__icon {
        line-height: 48px;
      }
    }
  }
}
.member-box {
  width: 550px;
  height: 110px;
  position: absolute;
  top: 70px;
  left: 25px;
  z-index: 99;
  background: #fff;
  // box-shadow: 1px 1px 5px #bbb;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  .no-result {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    color: #646566;
    height: 120px;
    p {
      margin-bottom: 10px;
    }
    .bind-member-active {
      color: #409eff;
      cursor: pointer;
    }
  }
  .history-box {
    padding: 10px;
  }
  .history-btn {
    margin-top: 10px;
    margin-left: 30px;
  }
}
.list {
  .flex-row {
    cursor: pointer;
    height: 60px;
    display: flex;
    align-items: center;
    padding: 0 10px;
    .msg {
      margin-left: 10px;
    }
    &:hover {
      background-color: #f1f1f1;
    }
  }
}
.member_bg {
  width: 100%;
  height: 56px;
  background-image: url("../../assets/images/money/member_bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 10px;
  .flex-row {
    align-items: center;
    .img {
      width: 30px;
      height: 30px;
    }
  }
  .icons {
    margin-right: 10px;
    font-size: 18px;
    cursor: pointer;
    &:hover {
      color: @blue;
    }
  }
}
</style>